import { render, staticRenderFns } from "./dialog-mobile.vue?vue&type=template&id=71dd87ac"
import script from "./dialog-mobile.vue?vue&type=script&lang=js"
export * from "./dialog-mobile.vue?vue&type=script&lang=js"
import style0 from "./dialog-mobile.vue?vue&type=style&index=0&id=71dd87ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports